/* global adRefs */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {AdController, AdService} from 'legacy-advertising';

export class Advertisement extends Component {
  static propTypes = {
    adService: PropTypes.shape({type: PropTypes.instanceOf(AdService)})
      .isRequired,
    positionId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.adElement = null;
  }

  setAdRef = element => {
    const {positionId} = this.props;

    this.adElement = element;

    adRefs.push({positionId, ref: element});
  };

  render() {
    const {adService, positionId} = this.props;

    return (
      <div style={{width: '300px', marginLeft: 'auto', marginRight: 'auto'}}>
        <AdController
          adService={adService}
          adSize={[[300, 250], 'fluid']}
          pageName="fh-profile"
          positionId={positionId}
          responsiveSizeMap="mapping300x250RightRail"
          ref={this.setAdRef}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  adService: state.adStore.adService,
});

export default connect(mapStateToProps)(Advertisement);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/Advertisement/index.js